<template>
  <div>
    <div class="is-flex is-align-items-center">
      <p><b>אזור (3)</b></p>
      <div class="horizontal_space"></div>
      <a @click="addArea" class="button is-info">הוסף אזור</a>
    </div>
    <div>
      <outsource-drushim-area-list-item v-for="(picked_area, index) in mutable_picked_areas" :area="picked_area" :zones_and_regions="zones_and_regions"
                                        v-model="mutable_picked_areas[index]" @remove_area="removeArea(index)" :key="index">
      </outsource-drushim-area-list-item>
    </div>
  </div>
</template>
<script>
import OutsourceDrushimAreaListItem from '@/components/OutsourceDrushimAreaListItem'
export default {
  name: 'outsource-drushim-areas',
  props: ['picked_areas', 'zones_and_regions'],
  data () {
    return {
      mutable_picked_areas: this.picked_areas
    }
  },
  watch: {
    picked_areas () {
      this.mutable_picked_areas = this.picked_areas
    },
    mutable_picked_areas () {
      if (this.hasDuplicateZones()) {
        this.$utils.emit('show_toast', { text: 'יש פעמיים את אותו אזור' })
        return
      }
      this.$emit('input', this.mutable_picked_areas)
    }
  },
  methods: {
    addArea () {
      let picked_areas = [...this.picked_areas]
      picked_areas.push({})
      this.$emit('input', picked_areas)
    },
    hasDuplicateZones () {
      let zone_ids = [...this.mutable_picked_areas].map(area => area.zone_id)
      return new Set(zone_ids).size !== zone_ids.length
    },
    removeArea (area_index) {
      this.mutable_picked_areas.splice(area_index, 1)
      this.$nextTick(() => {
        if (this.mutable_picked_areas.length == 0) {
          this.addArea()
        }
      })
    }
  },
  components: {
    OutsourceDrushimAreaListItem
  }
}
</script>
